// UI texts: settings, friends, notifications
export default {
  back: 'Back',
  title: 'Settings',
  account: {
    title: 'Account',
    guestTitle: 'Guest account',
    /** 29. 9. 2026: the reward for linking (email or Google), once per account. */
    linkBonus: 'Link your email to keep your survivor safe. Bonus: 3 Bandages, 50 Scrap, 20 Wood, 20 Metal and an Uncommon item.',
    email: 'Email',
    emailLinked: 'Signed in as {email}',
    emailPlaceholder: 'you@example.com',
    emailLabel: 'Email address',
    sendLink: 'Send link',
    sent: 'Check your inbox for a sign-in link. It works for 20 minutes.',
    devLink: 'Dev mode: open the magic link',
    invalidEmail: 'Enter a valid email address',
    google: 'Continue with Google',
    googleLinked: 'Google account linked',
    telegram: 'Telegram',
    telegramLinked: 'Telegram linked',
    telegramNote: 'Open AFTER DAY from the Telegram bot {bot} to link your account.',
    telegramNoteNoBot: 'Open AFTER DAY inside Telegram to link your account.',
    linked: 'Linked',
    since: 'Survivor since {date}',
  },
  notif: {
    title: 'Notifications',
    push: 'Push notifications',
    pushSub: 'Expedition returns, finished crafts and builds, a full heal.',
    email: 'Email',
    emailSub: 'A short note when something important happens.',
    emailNeeds: 'Add an email above to turn this on.',
    telegram: 'Telegram',
    telegramSub: 'Messages from the AFTER DAY bot.',
    telegramNeeds: 'Link Telegram to turn this on.',
    encounters: 'Encounter and event prompts',
    encountersSub: 'While I am online, ask me when my survivor meets someone or something happens out there.',
    energyFull: 'Your energy is full',
    energyFullSub: 'Tell me when my energy is full again: a push, or an email if no push reaches me. Once a day at most, never at night.',
    enablePush: 'Enable push notifications',
    pushState: 'Browser permission: {state}',
    perm: { granted: 'allowed', denied: 'blocked', default: 'not asked yet', unsupported: 'not supported here' },
    pushOn: 'Push notifications are on for this browser',
    pushFailed: 'Could not turn on push notifications',
    pushBlocked: 'Notifications are blocked. Allow them in your browser settings.',
    pushOff: 'Push is not configured on this server.',
  },
  look: {
    title: 'Appearance',
    titleLabel: 'Title',
    titleSub: 'Shown next to your name in stories and the feed.',
    none: 'No title',
    noneEarned: 'Earn titles through achievements: your first ambush, a close call, a Legendary find…',
    editLook: 'Edit appearance',
    /** 20. 10. 2026 (owner): renaming the survivor. */
    nameLabel: 'Survivor name',
    nameChange: 'Change',
  },
  privacy: 'Privacy',
  privacySub: 'What the game keeps about you, cookies, deleting your data.',
  community: {
    title: 'Community',
    discord: 'Join the Discord',
    discordSub: 'Patch notes, bug reports and other survivors.',
  },
  game: {
    title: 'Game',
    speed: 'This server runs at ×{n} game speed. Timers are shorter than on the live game.',
  },
  signOut: {
    button: 'Sign out',
    guestTitle: 'Sign out of a guest account?',
    guestBody: 'Guest progress lives only in this browser. Without an email you will not be able to come back to this survivor.',
    confirm: 'Sign out anyway',
  },
  friends: {
    title: 'Friends',
    add: 'Add a friend',
    addLabel: 'Survivor name or invite code',
    addPlaceholder: 'Name or code',
    addButton: 'Add',
    invite: 'Your invite',
    inviteBody: 'Friends who join through your link start with 30 Scrap and 2 Bandages. You get 50 Scrap and a Medkit.',
    code: 'Code',
    copy: 'Copy',
    copied: 'Copied',
    copyLink: 'Copy link',
    squad: 'Squad bonus',
    squadBody: 'Be out in the same zone as a friend: +10% loot and +5% XP for both of you, while you are both out there.',
    requests: 'Requests',
    accept: 'Accept',
    decline: 'Decline',
    list: 'Friends',
    outgoing: 'Sent requests',
    pending: 'Pending',
    cancel: 'Cancel',
    /** 28. 10. 2026 (player report): {n} = ENERGY_RULES.friendGift; the note says a gift costs nothing (it read as giving away your own). */
    gift: 'Gift +{n} energy',
    gifted: 'Sent today',
    giftDone: 'You gave {name} +{n} energy',
    giftNote: 'Gifts are free: your own energy stays the same. A gift can take a friend over their maximum, so it is never wasted.',
    remove: 'Remove',
    removeTitle: 'Remove {name}?',
    removeBody: 'You lose the Squad bonus and daily energy gifts with this survivor.',
    outIn: 'Out in {zone}',
    atCamp: 'At camp',
    seen: 'Seen {ago}',
    online: 'Online',
    emptyTitle: 'No friends yet',
    emptyBody: 'Add survivors by name or share your invite link. Friends send each other energy and earn the Squad bonus.',
    meta: 'LV {level} · {background}',
  },
  notifications: {
    title: 'Notifications',
    emptyTitle: 'Nothing new',
    /** Krug 5 (K8): crafting, buildings and the crew are toasts now, not rows. */
    emptyBody: 'Returns, lost tracks, friends and hordes show up here.',
    unread: 'Unread',
    /** The button on a toast that is not in the list (K8). */
    action: { workshop: 'Open Workshop', item: 'View item', building: 'View building', camp: 'Open Camp', skills: 'Open skills', revenge: 'Revenge' },
  },
} as const;
